//
//
//
//
//

export default {
  props: {
    type: Object,
    default: null
  }
}



// WEBPACK FOOTER //
// ./src/components/post/PostVideo.vue